(($)=>{

    const $headerLine = $('.header-line'),
          $siteHeader = $('.site-header'),
          $mobileMenu = $('#mobile-menu'),
          $searchPopup = $('.search-popup'),
          $cartWidget = $('.cart-widget'),
          $page = $('#page'),
          $masthead = $('#masthead'),
          $mobileMasthead = $('#mobile-masthead');

    function adjustHeaderShift($headerLine){

        let headerLineHeight = $headerLine.outerHeight();
        if(headerLineHeight){
            $siteHeader.css({transform: `translateY(${headerLineHeight}px)`});
            $mobileMenu.css({height: `calc(100vh - ${headerLineHeight}px)`});
            $searchPopup.css({top: `${headerLineHeight}px`});
            // these below are commented out because we shift headers via  $siteHeader.css({transform: `translateY(${headerLineHeight}px)`});
            // and we shift all page's content via `#page` padding-top.

            // $mobileMasthead.css({top: `${headerLineHeight}px`});
            // $masthead.css({top: `${headerLineHeight}px`});
            if(window.innerWidth < 768){
                $cartWidget.css({height: `calc(100vh - ${headerLineHeight}px)`});
            }else{
                $cartWidget.css({height: ''});
            }
        }

        // padding for page's container.
        let paddingTop = 0;
        if($masthead.is(':visible')){
            // desktop padding...
            paddingTop = headerLineHeight + $masthead.outerHeight();
        }else{
            paddingTop = headerLineHeight + $mobileMasthead.outerHeight();
        }
        $page.css({paddingTop: `${paddingTop}px`})
    }

    if($headerLine.length){
        adjustHeaderShift($headerLine);
        $(window).on('orientationchange resize',  () => {
            adjustHeaderShift($headerLine);
        });
    }

})(jQuery)